import type { Microsoft365User } from '@repo/api-gw-sdk';

/**
 * Eon backs up exactly two Microsoft 365 workloads per user, OneDrive and
 * Exchange, so a user holding neither has nothing Eon can protect.
 *
 * Licensing deliberately plays no part. A shared or resource mailbox carries no
 * Exchange license — its `hasMailbox` is observed from the usage report rather
 * than an entitlement — and is backed up and restored like any other mailbox.
 */
export function isMicrosoft365UserSupported(user: Microsoft365User): boolean {
  return !!user.hasMailbox || !!user.hasOnedrive;
}

export const MICROSOFT365_UNSUPPORTED_REASON =
  'This user has neither an Exchange mailbox nor a OneDrive, so Eon has no workload to back up for them.';

/**
 * Whether a directory user is the one a recorded id points at. Object ids
 * compare case-insensitively — the directory treats them as case-insensitive,
 * so a recorded id's casing may differ from the stored row. Principal names
 * only count on exact match: a loose check would hit other addresses that
 * contain the id as a substring.
 */
export function microsoft365UserIdMatches(
  user: Microsoft365User,
  id: string
): boolean {
  return (
    user.userId?.toLowerCase() === id.toLowerCase() ||
    user.userPrincipalName?.toLowerCase() === id.toLowerCase()
  );
}
